(() => {
  const push = (event, ecommerce) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ecommerce });
  };

  const itemFromElement = (element) => {
    if (!element) return null;
    const item = {
      item_id: element.dataset.itemId || '',
      item_name: element.dataset.itemName || '',
      item_brand: 'BLOOMLY',
      item_variant: element.dataset.itemVariant || '',
      price: Number(element.dataset.price || 0),
      quantity: Number(element.dataset.quantity || 1)
    };
    if (element.dataset.listId) item.item_list_id = element.dataset.listId;
    if (element.dataset.listName) item.item_list_name = element.dataset.listName;
    return item;
  };

  const list = document.querySelector('[data-ga4-list]');
  if (list) {
    const items = [...list.querySelectorAll('[data-ga4-item]')].map(itemFromElement).filter(Boolean);
    const itemListId = list.dataset.listId || items[0]?.item_list_id || 'product_list';
    const itemListName = list.dataset.listName || items[0]?.item_list_name || 'Product list';
    if (items.length) push('view_item_list', { item_list_id: itemListId, item_list_name: itemListName, items });
  }

  const cartPayload = (root = document) => {
    const items = [...root.querySelectorAll('[data-cart-ga4-item]')].map(itemFromElement).filter(Boolean);
    const value = Number(root.querySelector('[data-cart-total]')?.dataset.cartTotal || items.reduce((total, item) => total + (item.price * item.quantity), 0));
    return { currency: 'GBP', value, items };
  };

  const cartPage = document.querySelector('[data-cart-page]');
  if (cartPage) push('view_cart', cartPayload(cartPage));

  const announcementTrack = document.querySelector('.bl-announcement__track');
  const announcementItems = announcementTrack ? [...announcementTrack.querySelectorAll('.bl-announcement__item')] : [];
  if (announcementItems.length === 3 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let activeAnnouncement = 0;
    announcementTrack.classList.add('is-rotating');
    announcementItems[0].classList.add('is-active');
    window.setInterval(() => {
      announcementItems[activeAnnouncement].classList.remove('is-active');
      activeAnnouncement = (activeAnnouncement + 1) % announcementItems.length;
      announcementItems[activeAnnouncement].classList.add('is-active');
    }, 4000);
  }

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-product-link]');
    if (productLink) {
      const item = itemFromElement(productLink.closest('[data-ga4-item]'));
      if (item) push('select_item', { item_list_id: item.item_list_id, item_list_name: item.item_list_name, items: [item] });
    }

    const cartTrigger = event.target.closest('[data-cart-trigger]');
    if (cartTrigger) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(cartTrigger);
        push('view_cart', cartPayload(drawer));
      }
    }

    const checkout = event.target.closest('[data-ga4-checkout], #CartDrawer-Checkout, #checkout');
    if (checkout) push('begin_checkout', cartPayload(checkout.closest('[data-cart-page], cart-drawer') || document));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-static-product-form]');
    if (!form) return;
    event.preventDefault();
    const item = itemFromElement(form.closest('[data-ga4-item]'));
    if (item) item.quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    if (item) push('add_to_cart', { currency: 'GBP', value: item.price * item.quantity, items: [item] });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bl-header details[open]').forEach((detail) => {
      detail.removeAttribute('open');
      detail.querySelector('summary')?.focus();
    });
  });

  document.querySelectorAll('.bl-header details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (detail.classList.contains('bl-mobile-menu')) {
        detail.querySelector('summary')?.setAttribute('aria-label', detail.open ? 'Close menu' : 'Open menu');
      }
      if (!detail.open) return;
      detail.parentElement?.querySelectorAll('details[open]').forEach((sibling) => {
        if (sibling !== detail) sibling.removeAttribute('open');
      });
    });
  });

  const footerQuery = window.matchMedia('(min-width: 750px)');
  const syncFooterAccordions = () => {
    document.querySelectorAll('.bl-footer details').forEach((detail) => {
      detail.open = footerQuery.matches;
    });
  };
  syncFooterAccordions();
  footerQuery.addEventListener('change', syncFooterAccordions);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source, productVariantId }) => {
      if (source !== 'product-form') return;
      const form = document.querySelector(`product-form form [name="id"][value="${productVariantId}"]`)?.closest('product-form');
      const item = itemFromElement(form?.closest('[data-ga4-item]'));
      if (item) item.quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
      if (item) push('add_to_cart', { currency: 'GBP', value: item.price * item.quantity, items: [item] });
    });
  }
})();
